import {
  Box,
  Container,
  Divider,
  Link,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import street from "../../images/street.jpeg";
import ballroom from "../../images/ballroom.jpeg";
import cottages from "../../images/cottages.jpg";
import ass from "../../images/ass.jpeg";
import linna from "../../images/linna.jpg";
export function InfoPage() {
  return (
    <Box
      sx={{
        py: { xs: 4, md: 6 },
        minHeight: "100vh",
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={6}>
          <Stack spacing={2} textAlign="center">
            <Typography
              variant="h3"
              sx={{ fontFamily: "serif", fontWeight: 800, letterSpacing: 1.2 }}
            >
              Wedding Information
            </Typography>
          </Stack>

          {/* CEREMONY */}
          <NewsSection
            title="Wedding Ceremony"
            imageAlt="Ceremony picture placeholder"
            backgroundImage={street}
          >
            <Typography sx={bodyText}>
              The wedding ceremony will be held at <strong>14:00</strong>{" "}
              outdoors at <strong>Aulangon Suuri Huvila</strong>. In case of
              rain, the ceremony will be moved indoors.
            </Typography>

            <Typography sx={bodyText}>
              <strong>Address:</strong> Aulangon-Heikkilän tie 168, 13900 Pekola
            </Typography>

            <Typography sx={bodyText}>
              <strong>Website:</strong>{" "}
              <StyledLink
                href="https://www.evonluonto.fi/kohde/aulangon-suuri-huvila/"
                label="evonluonto"
              />
            </Typography>

            <Typography sx={bodyText}>
              <strong>Getting there:</strong> Arriving by car or taxi is
              easiest. Bus lines 2 and 2A run from Hämeenlinna city center.
            </Typography>

            <Typography sx={bodyText}>
              <strong>Parking:</strong> There is sufficient parking available
              onsite for all guests.
            </Typography>

            <Typography sx={bodyText}>
              We have booked a bus to transport guests from the ceremony to the
              wedding dinner venue.
            </Typography>
          </NewsSection>

          {/* DINNER */}
          <NewsSection
            title="Wedding Dinner"
            imageAlt="Dinner venue picture placeholder"
            backgroundImage={ballroom}
            backgroundPosition="center"
          >
            <Typography sx={bodyText}>
              The wedding dinner will begin at <strong>17:00</strong> at{" "}
              <strong>Hämeenlinnan Palokuntatalo</strong>.
            </Typography>

            <Typography sx={bodyText}>
              <strong>Address:</strong> Palokunnankatu 18, 13100 Hämeenlinna
            </Typography>

            <Typography sx={bodyText}>
              <strong>Website:</strong>{" "}
              <StyledLink
                href="https://palokunnantalo.fi/"
                label="palokunnantalo"
              />
            </Typography>

            <Typography sx={bodyText}>
              <strong>Getting there:</strong> You may use our pre-booked bus
              from the ceremony, take a taxi, or arrive by car. Free parking is
              available in the surrounding area.
            </Typography>

            <Typography sx={bodyText}>
              <strong>Dinner program:</strong> Doors open at 17:00. The formal
              program will start at 17:30. Open bar available from 17:00 until
              01:00.
            </Typography>
          </NewsSection>

          <NewsSection
            title="Dress code"
            backgroundImage={ass}
            backgroundPosition="50% 40%"
          >
            <Typography sx={bodyText}>
              <strong>Dress code:</strong> According to my soon-to-be wife:
              "Dress to impress with an effortless summer feel, perfect for an
              outdoor and indoor celebration. Color: soft neutrals, pastels,
              florals, or vibrant summer tones simply as inspiration, and keep
              it light, airy, and season-appropriate"
            </Typography>

            <Typography sx={bodyText}>
              <strong>
                I only understand 50% of the above that myself. To all the other
                clueless men (or women) out there:
              </strong>{" "}
              Formal, semi-formal, or smart casual — just use a shirt of your
              choice and a blazer if you have one.
            </Typography>
          </NewsSection>

          <NewsSection
            title="Getting to Hämeenlinna"
            backgroundImage={linna}
            backgroundPosition="center"
          >
            <Typography sx={bodyText}>
              <strong>By train:</strong> Getting to Hämeenlinna from Helsinki is
              easy: direct trains run about once an hour and take roughly one
              hour with VR — see schedules and tickets at
              <StyledLink href="https://www.vr.fi/?from=HKI&to=HL" label="VR" />
            </Typography>

            <Typography sx={bodyText}>
              <strong>Hämeenlinna: </strong>
              is a charming lakeside town rich in history and nature — during
              your stay, we recommend exploring the beautiful Häme Castle, just
              a short walk from the center or few km away from the cottage
            </Typography>
          </NewsSection>

          {/* ACCOMMODATION */}
          <SectionHeadline title="Accommodation" />

          <NewsSection
            title="Aulangon Rauha Cottages"
            imageAlt="Aulangon Rauha picture placeholder"
            backgroundImage={cottages}
          >
            <Bullet>
              Price: €130 per adult for the full stay from Thursday to Monday.
              You can arrive/leave when you want, but the price includes the
              whole stay.
            </Bullet>
            <Bullet>
              Accommodation can be booked while completing your RSVP. Simply
              indicate that you would like a cottage and from which day. Since
              there is limited cottage availability, please RSVP as quick as
              possible if you want to stay in the cottages.
            </Bullet>
            <Bullet>
              Approximately 24 bedrooms are reserved for our wedding guests
              across multiple neighboring cottages.
            </Bullet>
            <Bullet>
              Access to all amenities, including swimming, saunas, jacuzzis,
              game rooms, BBQ areas, and beautiful Finnish nature.
            </Bullet>
            <Bullet>
              Breakfast is not included. All cottages have fully equipped
              kitchens.
            </Bullet>
            <Bullet>
              Recommended for guests who would like a mini vacation and plan to
              arrive on Thursday or Friday.
            </Bullet>
            <Bullet>
              Recommended for guests who want to socialize with us and other
              guests before the wedding.
            </Bullet>
            <Bullet>
              This is not luxury accommodation — rooms are simple and practical.
            </Bullet>
            <Bullet>
              Bring your own bed linen (bed linen, duvet cover and pillowcasing)
              and towels. For guests arriving from abroad, we will arrange extra
              bed lines.
            </Bullet>
            <Typography sx={bodyText}>
              <strong>Website:</strong>{" "}
              <StyledLink
                href="https://www.evonluonto.fi/tapahtumille/aulangon-rauha/"
                label="evonluonto"
              />
            </Typography>
          </NewsSection>

          <Stack spacing={2}>
            <Typography sx={subHeadline}>Hotel Scandic Aulanko</Typography>
            <Bullet>
              Walking distance from both the cottages and the ceremony venue.
            </Bullet>
            <Bullet>
              Recommended for guests who prefer slightly more comfort but still
              wish to join Thursday/Friday events.
            </Bullet>
            <Bullet>Suitable for families with small children.</Bullet>
            <Bullet>Prices start at approximately €150 per night.</Bullet>
            <Bullet>You will need to book this accommodation yourself.</Bullet>
            <Bullet>
              Website:{" "}
              <StyledLink
                href="https://www.scandichotels.com/fi/hotellit/scandic-aulanko"
                label="scandic aulanko"
              />
            </Bullet>
          </Stack>

          <Stack spacing={2}>
            <Typography sx={subHeadline}>
              Hotel Scandic Hämeenlinna City
            </Typography>
            <Bullet>Walking distance from the wedding dinner venue.</Bullet>
            <Bullet>
              Recommended for guests arriving on Saturday and staying one night.
            </Bullet>
            <Bullet>Prices start at approximately €180 per night.</Bullet>
            <Bullet>You will need to book this accommodation yourself.</Bullet>
            <Bullet>
              Website:{" "}
              <StyledLink
                href="https://www.scandichotels.com/fi/hotellit/scandic-hameenlinna-city"
                label="scandic city"
              />
            </Bullet>
          </Stack>

          <NewsSection title="Wedding gift" disableImage>
            <Typography sx={bodyText}>
              We're grateful to celebrate our special day with you and your
              presence is the best gift we could ask for! If you want to give a
              little contribution toward our honeymoon fund would be warmly
              appreciated as we begin this next chapter of our lives.
            </Typography>

            <Typography sx={bodyText}>
              <strong>Banknumber (EU): </strong>
              FI94 5092 0920 5802 87 (BIC/Swift: OKOYFIHH, Reciever: NGUYEN MINH
              PHUONG)
            </Typography>

            <Typography sx={bodyText}>
              <strong>Mobile pay (Finland): </strong>
              +358 40 372 4121 (Christopher Harju)
            </Typography>

            <Typography sx={bodyText}>
              <strong>Banknumber (Vietnam): </strong>
              0653 8370 301 (bank: TMCP Tiên Phong - TPBank, reciever: NGUYEN
              MINH PHUONG)
            </Typography>
          </NewsSection>

          {/* AGENDA */}
          <SectionHeadline title="Wedding Schedule 2.7.2026 - 6.7.2026" />

          <AgendaDay title="Thursday 2.7.2026">
            <List>
              <ListItem>
                16:00: Cottage check-in begins at Aulangon Rauha.
              </ListItem>
              <ListItem>
                18:00: Socializing, board games, jacuzzis, swimming, and sauna.
                You are welcome to join regardless of your accommodation choice.
                Please bring your own food and drinks — we will provide some
                snacks and drinks. There are all you need kitchen appliances and
                outdoor BBQ's to prepare any food you want. You are welcome to
                make your own program too there are boats, you can go for
                example fishing or trekking
              </ListItem>
            </List>
          </AgendaDay>

          <AgendaDay title="Friday 3.7.2026">
            <List>
              <ListItem>
                10:00: Cottage check-in at any time during the day. Please call
                us if you arrive at odd hours and we'll make sure there is
                someone to show you to your room/cottage.
              </ListItem>
              <ListItem>
                15:00: Voluntary help decorating the wedding dinner ballroom at
                Palokunnantalo
              </ListItem>
              <ListItem>
                19:00: Pre party BBQ, sauna, swimming, and jacuzzis and more.
                You are welcome to join regardless of your accommodation. Please
                bring your own food and drinks — we will provide some snacks and
                drinks
              </ListItem>
            </List>
          </AgendaDay>

          <AgendaDay title="Saturday 4.7.2026">
            <List>
              <ListItem>14:00 Wedding Ceremony at Aulanko</ListItem>
              <ListItem>14:30 Celebration bubbles & snacks</ListItem>
              <ListItem>14:45 Group photos</ListItem>
              <ListItem>
                16:30 Group bus to wedding dinner venue (Palokunnantalo)
              </ListItem>
              <ListItem>17:00 Venue entrance, open bar & socializing.</ListItem>
              <ListItem>
                17:30 Wedding celebration and dinner program starts
              </ListItem>
              <ListItem>
                21:00 Ballroom party, dancing & late evening program.
              </ListItem>
              <ListItem>
                01:00 Doors close. We recommend using taxi or public transport
                to get back to your accomodation.
              </ListItem>
            </List>
          </AgendaDay>

          <AgendaDay title="Sunday 5.7.2026 - Monday 6.7.2026">
            <List>
              <ListItem>
                11:00: Voluntary help cleaning the ballroom (Palokunnantalo)
              </ListItem>
              <ListItem>
                Sunday/Monday: Latest checkout is 09:00 Monday morning from
                Aulanko Cottages
              </ListItem>
            </List>
          </AgendaDay>
        </Stack>
      </Container>
    </Box>
  );
}

/* ---- Components & Styles ---- */

function NewsSection({
  title,
  imageAlt,
  children,
  backgroundImage,
  backgroundPosition,
  disableImage = false,
}: any) {
  return (
    <Stack spacing={3}>
      <SectionHeadline title={title} />
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack spacing={1.5}>{children}</Stack>
        </Grid>
        {!disableImage && (
          <Grid size={{ xs: 12, md: 6 }}>
            <ImagePlaceholder
              alt={imageAlt}
              backgroundImage={backgroundImage}
              backgroundPosition={backgroundPosition}
            />
          </Grid>
        )}
      </Grid>
    </Stack>
  );
}

function SectionHeadline({ title }: any) {
  return (
    <Typography
      variant="h4"
      sx={{
        fontFamily: "serif",
        fontWeight: 900,
        borderBottom: "2px solid #1a1a1a",
        pb: 1,
      }}
    >
      {title}
    </Typography>
  );
}

function AgendaDay({ title, children }: any) {
  return (
    <Stack spacing={1}>
      <Typography sx={{ fontFamily: "serif", fontWeight: 800, fontSize: 22 }}>
        {title}
      </Typography>
      <Typography sx={bodyText}>{children}</Typography>
    </Stack>
  );
}

function Bullet({ children }: any) {
  return <Typography sx={bodyText}>• {children}</Typography>;
}

function StyledLink({ href, label }: any) {
  return (
    <Link href={href} target="_blank" rel="noreferrer" sx={{ fontWeight: 600 }}>
      {label || href}
    </Link>
  );
}

function ImagePlaceholder({
  alt,
  backgroundImage,
  backgroundPosition = "bottom",
}: any) {
  return (
    <Box
      sx={{
        height: 400,
        border: "3px solid #1a1a1a",
        background: "#fffdf7",
        display: "grid",
        placeItems: "center",
        fontFamily: "serif",
        fontStyle: "italic",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: backgroundPosition,
      }}
    />
  );
}

const bodyText = {
  fontFamily: "serif",
  fontSize: 18,
  lineHeight: 1.7,
  color: "#1a1a1a",
} as const;

const subHeadline = {
  fontFamily: "serif",
  fontWeight: 800,
  fontSize: 22,
} as const;
/**
 *
 * Wedding ceremony
 * {PICTURE HERE}
 * The wedding ceremony will be helt at 14.00 outside at Aulangon suuri huvila.
 * If it rains it will be moved inside.
 * Address: Aulangon-Heikkilän tie 168, 13900 Pekola
 * Website: https://www.evonluonto.fi/kohde/aulangon-suuri-huvila/
 * Dresscode: Formal, semi-formal or smart casual with weather consideration
 * Getting there: It is easiest to arrvive with your own car or taxi. There is also a buss connection (2 and 2A) from Hämeenlinna center.
 * Parking: There is enough parking onsite for all guests.
 *
 * We have booked a buss to transport for our guests from the ceremony to the wedding dinner.
 *
 *
 * Wedding dinner
 * {PICTURE HERE}
 * The wedding dinner will be helt at 17.00 at Hämeenlinnan Palokuntatalo
 * Address: Palokunnankatu 18, 13100 Hämeenlinna
 * Website: https://palokunnantalo.fi/
 * Dresscode: Formal, semi-formal or smart casual.
 * Getting there: You can use our pre booked bus to arrive from the wedding ceremony, or you can take your own taxi. If you choose to come with car, there is free parking around the area
 * Dinner: The program starts at 17.00, The buffet dinner will start at 17.30. Our open bar starts at 17.00 and is open until 01.00 AM. Our
 *
 * Accomodation
 *
 * Stay with us at Aulangon Rauha.
 * {PICTURE HERE}
 * - Price 130e / person includes the whole stay from Thursday - Sunday/Monday. You can natuarlly decide to arrive on Friday too.
 * - Can be booked while you make your RSVP. Answer in the form that you want a cottage and from which day.
 * - Around 24 bedrooms available for us and our wedding guests in multiple cottages next to each other
 * - Access to all the amenities (swimming, saunas, jacuzzis, game rooms, BBQs etc) and amazing finnish nature
 * - Does not include breakfast. All cottages comes with fully equipped kitchens.
 * - Recommended for guests that wants to have a "mini vacation" and arrive on either Thursday or Friday
 * - Recommended for guests that want to socialize with us and the other guests before the wedding
 * - This is not a luxury accomodation, so the rooms are quite bare bones.
 * - Bring your own bed linen and towels. If you arrive from abroad, let us know and we will lend you some.
 * - Website: https://www.evonluonto.fi/tapahtumille/aulangon-rauha/
 *
 * Hotel Scandic Aulanko
 * - Walking distance from the cottages and our wedding ceremony location
 * - Recommended for people who wants slightly more luxury but still want to join thursday/friday events at the Aulanko cottages
 * - Suitable for families with small children
 * - Prices starts at around 150 euroes per night
 * - You need to book this yourself
 * - website: https://www.scandichotels.com/fi/hotellit/scandic-aulanko
 *
 * Hotel Scandic Hämeenlinna City
 * - Walking distance from our Wedding dinner
 * - Recommended for people arriving on Saturday and just staying one night
 * - Prices starts at around 180 euroes per night
 * - You need to book this yourself
 * - website: https://www.scandichotels.com/fi/hotellit/scandic-hameenlinna-city
 *
 * Agenda
 * Thursday
 * - Aulangon rauha cottages check-in starting from 17.00
 * - Socialising, board games, jacuzzis, swimming and sauna in the evening. You can join our events regardless of your accomondation
 * - Bring your own food/drinks. We will provide some snacks and drinks on the house.
 *
 * Friday
 * - Check-in to Aulangon rauha cottages at any time.
 * - Voluntary help us decorate the wedding dinner ballroom at 16.00
 * - BBQ, Sauna, Swimming, Jacuzzis starting from 19.30. You can join our events regardless of your accomondation.
 *
 * Saturday
14.00 Ceremony at Aulanko
14.30 Bubbles & Snacks
14.45 Group Photos
16.30 Group Bus to wedding dinner
17.00 Venue party entrance, Open bar & socialising
17.30 Wedding dinner & formal program starts
21.00 Party, dance, and other other late evening program starts
01.00 Doors close

Sunday
11.00 Voluntary help us clean Ballroom
Checkout from Aulanko cottages at any time. Latest 9.00 AM Monday morning.

Contact
Groom:
Bride:
Bestmen:
Bridesmaids:
 */
